'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.forEach.implement(Array, function (effect, arr) {
  return arr.forEach(effect);
});

_TransmuteCollection.forEach.implementInherited(_immutable.Iterable, function (effect, subject) {
  return subject.forEach(effect);
});

_TransmuteCollection.forEach.implement(Object, function (effect, obj) {
  var keys = Object.keys(obj);
  var len = keys.length;
  for (var i = 0; i < len; i++) {
    var key = keys[i];
    effect(obj[key], key, obj);
  }
  return obj;
});

exports.default = _TransmuteCollection.forEach;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_forEach.js
// module id = 361
// module chunks = 0 1